import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Compbaser} from "../compbaser/compbases";
import {MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource} from "@angular/material/tree";
import {FlatTreeControl, NestedTreeControl} from "@angular/cdk/tree";
import {Observable, of as ofObservable, of as observableOf} from "rxjs";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../services";
import {SelectionModel} from "@angular/cdk/collections";
import {ICategoryCheckItemNode, ICategoryItemFlatNode, ICategoryTreeNode, ICategoryTreeSelection} from "./tree-service/tree-data.model";
import {TreeFunctionService} from "./tree-service/tree-function.service";
import {MatDialog} from '@angular/material/dialog';
import * as _ from "lodash";

@Component({
    selector: 'app-category-tree',
    styleUrls: ['./category-tree.component.scss'],
    templateUrl: './category-tree.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CategoryTreeComponent extends Compbaser implements OnInit {

    @Input() createMode: boolean;
    @Input() filterMode: boolean;

    @Input()
    set setCategoryValues(i_value) {
        if (i_value) {
            this.categoryData = i_value;
        } else {
            this.categoryData = [];
        }
        this.cd.markForCheck();
        this.setDataSource();
    }

    @Input() expandAll = true;
    @Input() markTreeSelection = '#FF0000';

    @Output() updateTree: EventEmitter<any> = new EventEmitter<any>();
    @Output() updateTreeSelection: EventEmitter<any> = new EventEmitter<ICategoryTreeSelection>();
    @Output() undoTree: EventEmitter<any> = new EventEmitter<any>();
    @Output() redoTree: EventEmitter<any> = new EventEmitter<any>();

    // @ViewChild('treeSelector') tree: MatTree<any>;
    disableUndo = true;
    disableRedo = true;

    filter = '';
    categoryData;
    nestedTreeControl: NestedTreeControl<ICategoryTreeNode>;
    nestedDataSource: MatTreeNestedDataSource<ICategoryTreeNode>;


    /** Map from flat node to nested node. This helps us finding the nested node to be modified */
    flatNodeMap: Map<ICategoryItemFlatNode, ICategoryCheckItemNode> = new Map<ICategoryItemFlatNode, ICategoryCheckItemNode>();

    /** Map from nested node to flattened node. This helps us to keep the same object for selection */
    nestedNodeMap: Map<ICategoryCheckItemNode, ICategoryItemFlatNode> = new Map<ICategoryCheckItemNode, ICategoryItemFlatNode>();

    /** A selected parent node to be inserted */
    selectedParent: ICategoryItemFlatNode | null = null;

    /** The new item's name */
    newItemName = '';

    treeControl: FlatTreeControl<ICategoryItemFlatNode>;

    treeFlattener: MatTreeFlattener<ICategoryCheckItemNode, ICategoryItemFlatNode>;

    dataSource: MatTreeFlatDataSource<ICategoryCheckItemNode, ICategoryItemFlatNode>;

    /** The selection for checklist */
    checklistSelection = new SelectionModel<ICategoryItemFlatNode>(true /* multiple */);
    xcheckListSelection = new SelectionModel<ICategoryItemFlatNode>(true /* multiple */);
    clickSelection = new SelectionModel<ICategoryTreeNode>(false /* single */);

    constructor(
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        public storeSelector: StoreSelectorsService,
        private service: TreeFunctionService,
        public override dialog: MatDialog) {
        super(dialog);
        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl<ICategoryItemFlatNode>(this.getLevel, this.isExpandable);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

        this.nestedTreeControl = new NestedTreeControl<ICategoryTreeNode>(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUndoable().subscribe((status: boolean) => {
                this.disableUndo = status;
            })
        );
        this.cod(
            this.storeSelector.getRedoable().subscribe((status: boolean) => {
                this.disableRedo = status;
            })
        );
    }

    setDataSource() {
        if (!this.createMode) {
            this.checklistSelection.clear();
            this.dataSource.data = this.categoryData;
            this.nestedDataSource.data = [];
            if (this.expandAll) {
                this.treeControl.expandAll();
            }
        } else {
            this.clickSelection.clear();
            this.nestedDataSource.data = this.categoryData;
            this.nestedTreeControl.dataNodes = this.nestedDataSource.data;
            this.dataSource.data = [];
            if (this.expandAll) {
                this.nestedTreeControl.expandAll();
            }
        }
        this.xcheckListSelection.clear();
    }

    private _getChildren = (node: ICategoryTreeNode) => observableOf(node.Children);
    hasNestedChild = (_: number, nodeData: ICategoryTreeNode) => nodeData.Children.length > 0;

    refreshTreeData(updatedNode: ICategoryTreeNode, action) {
        const data = this.nestedDataSource.data;
        this.nestedDataSource.data = null;
        this.nestedDataSource.data = data;
        // this.tree.renderNodeChanges(data);
        this.updateTree.emit({
            items: this.nestedDataSource.data,
            item: updatedNode,
            action
        });
    }

    clearFilterSelection() {
        this.filter = '';
    }

    clearSelection() {
        this.xcheckListSelection.clear();
        this.checklistSelection.clear();
        this.cd.markForCheck();
    }

    addNode(node: ICategoryTreeNode) {
        // node.Id = this.service.findNodeMaxId(this.nestedDataSource.data) + 1;
        this.nestedDataSource.data.push(node);
        this.refreshTreeData(node, 'root');
    }

    addChildNode(childrenNodeData) {
        // childrenNodeData.node.Id = this.service.findNodeMaxId(this.nestedDataSource.data) + 1;
        childrenNodeData.currentNode.Children.push(childrenNodeData.node);
        this.refreshTreeData(childrenNodeData.node, 'add');
    }

    onNodeSelected(node: ICategoryTreeNode) {
        this.clickSelection.clear();
        this.clickSelection.toggle(node);
        // e.Color = _.random(1, 2) === 1 ? 'green' : 'red';
    }

    editNode(nodeToBeEdited) {
        const fatherElement: ICategoryTreeNode = this.service.findFatherNode(nodeToBeEdited.currentNode.Id, this.nestedDataSource.data);
        let elementPosition: number;

        nodeToBeEdited.node.Id = nodeToBeEdited.currentNode.Id;
        if (fatherElement[0]) {
            fatherElement[0].Children[fatherElement[1]] = nodeToBeEdited.node;
        } else {
            elementPosition = this.service.findPosition(nodeToBeEdited.currentNode.Id, this.nestedDataSource.data);
            this.nestedDataSource.data[elementPosition] = nodeToBeEdited.node;
        }
        this.refreshTreeData(nodeToBeEdited.node, 'update');
    }

    deleteNode(nodeToBeDeleted: ICategoryTreeNode) {
        const deletedElement: ICategoryTreeNode = this.service.findFatherNode(nodeToBeDeleted.Id, this.nestedDataSource.data);
        let elementPosition: number;
        const msg = this.translocoService.translate('general.sureRemove', {}, this.translocoService.getActiveLang());
        this.openDialog(`${msg} ` + nodeToBeDeleted.Name + ` `, {showCancel: true}, (v) => {
            if (!v) return;
            if (deletedElement[0]) {
                deletedElement[0].Children.splice(deletedElement[1], 1);
            } else {
                elementPosition = this.service.findPosition(nodeToBeDeleted.Id, this.nestedDataSource.data);
                this.nestedDataSource.data.splice(elementPosition, 1);
            }
            this.refreshTreeData(nodeToBeDeleted, 'delete');

        });

        // if (window.confirm('Are you sure you want to delete ' + nodeToBeDeleted.Name + '?')) {

        // }
    }

    getLevel = (node: ICategoryItemFlatNode) => {
        return node.level;
    }

    isExpandable = (node: ICategoryItemFlatNode) => {
        return node.expandable;
    }

    getChildren = (node: ICategoryCheckItemNode): Observable<ICategoryCheckItemNode[]> => {
        return ofObservable(node.children);
    }

    hasChild = (_: number, _nodeData: ICategoryItemFlatNode) => {
        return _nodeData.expandable;
    }

    hasNoContent = (_: number, _nodeData: ICategoryItemFlatNode) => {
        return _nodeData.item === '';
    }

    /**
     * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
     */
    transformer = (node: ICategoryCheckItemNode, level: number) => {
        const flatNode = this.nestedNodeMap.has(node) && this.nestedNodeMap.get(node)!.item === node.item
            ? this.nestedNodeMap.get(node)!
            : new ICategoryItemFlatNode();
        flatNode.id = node.id;
        flatNode.item = node.item;
        flatNode.level = level;
        flatNode.expandable = !!node.children && node.children.length > 0;
        this.flatNodeMap.set(flatNode, node);
        this.nestedNodeMap.set(node, flatNode);

        if (node.selected) this.checklistSelection.toggle(flatNode);
        return flatNode;
    }


    /** Whether all the descendants of the node are selected */
    // @Memoizee({})
    descendantsAllSelected(node: ICategoryItemFlatNode): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const allSelected = descendants.every(child => this.checklistSelection.isSelected(child));
        this.selectCheckListModel(node, allSelected);
        return allSelected;
    }

    /** Whether part of the descendants are selected */
    // @Memoizee({})
    descendantsPartiallySelected(node: ICategoryItemFlatNode): boolean {
        if (this.descendantsAllSelected(node)) {
            this.selectXCheckListModel(node, false);
            return false;
        } else {
            const descendants = this.treeControl.getDescendants(node);
            const flag = descendants.some(child => this.checklistSelection.isSelected(child));
            this.selectXCheckListModel(node, flag);
            return flag;
        }
    }

    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    todoItemSelectionToggle(node: ICategoryItemFlatNode): void {
        this.checklistSelection.toggle(node);
        const selected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        selected ? this.checklistSelection.select(...descendants) : this.checklistSelection.deselect(...descendants);
        setTimeout(() => {
            this.updateSelection(descendants, selected);
        });
        this.cd.detectChanges();
    }

    toggleNode(node: ICategoryItemFlatNode): void {
        this.checklistSelection.toggle(node);
        setTimeout(() => {
            this.updateSelection([node], this.checklistSelection.isSelected(node));
        });
        this.cd.detectChanges();
    }

    /** Select the category so we can insert the new item. */
    addNewItem(node: ICategoryItemFlatNode) {
        const parentNode = this.flatNodeMap.get(node);
        // this.database.insertItem(parentNode!, '');
        this.insertItem(parentNode!, '');
        this.treeControl.expand(node);
    }

    /** Save the node to database */
    saveNode(node: ICategoryItemFlatNode, itemValue: string) {
        const nestedNode = this.flatNodeMap.get(node);
        // this.database.updateItem(nestedNode!, itemValue);
        this.updateItem(nestedNode!, itemValue);
    }

    /** Toggle expand all / collapse all */
    toggleExpandAll() {
        if (this.expandAll) {
            this.expandAll = false;
            this.createMode ? this.nestedTreeControl.collapseAll() : this.treeControl.collapseAll();

        } else {
            this.expandAll = true;
            this.createMode ? this.nestedTreeControl.expandAll() : this.treeControl.expandAll();
        }
    }

    onClickUndoTree() {
        this.undoTree.emit();
    }

    onClickRedoTree() {
        this.redoTree.emit();
    }

    // search filter logic start
    filterLeafNode(node: ICategoryItemFlatNode): boolean {
        if (!this.filter) {
            return false;
        }
        return node.item.toLowerCase().indexOf(this.filter?.toLowerCase()) === -1;
    }

    filterParentNode(node: ICategoryItemFlatNode): boolean {
        if (!this.filter || node.item.toLowerCase().indexOf(this.filter?.toLowerCase()) !== -1) {
            return false;
        }
        const descendants = this.treeControl.getDescendants(node);

        if (descendants.some(
                (descendantNode) => descendantNode.item.toLowerCase().indexOf(this.filter?.toLowerCase()) !== -1
        )) {
            return false;
        }
        return true;
    }
    // search filter logic end

    /** Add an item to to-do list */
    private insertItem(parent: ICategoryCheckItemNode, name: string) {
        const child = <ICategoryCheckItemNode> {item: name};
        if (parent.children) {
            parent.children.push(child);
            // this.dataSource.data = this.data;
            // this.dataChange.next(this.data);
        }
    }

    private updateItem(node: ICategoryCheckItemNode, name: string) {
        node.item = name;
        // this.dataChange.next(this.data);
    }

    private updateSelection(nodes: ICategoryItemFlatNode[], isSelected) {
        if (nodes) {
            const nodeIds = nodes.map((node) => node.id);
            const checklist = this.checklistSelection?.selected.concat(this.xcheckListSelection?.selected);
            this.updateTreeSelection.emit({
                ids: nodeIds,
                selected: isSelected,
                checklist
            });
        }
    }

    private selectXCheckListModel(node, isSelect = true) {
        if (isSelect) {
            if (!this.xcheckListSelection.isSelected(node)) {
                this.xcheckListSelection.toggle(node);
            }
        } else {
            if (this.xcheckListSelection.isSelected(node)) {
                this.xcheckListSelection.toggle(node);
            }
        }
    }

    private selectCheckListModel(node, isSelect = true) {
        if (isSelect) {
            if (!this.checklistSelection.isSelected(node)) {
                this.checklistSelection.toggle(node);
            }
        } else {
            if (this.checklistSelection.isSelected(node)) {
                this.checklistSelection.toggle(node);
            }
        }
    }
}

